<div class="custom-form" [class.readonly]="readonlyInput()">
  @if (customForm) {
    <hau-form [formGroup]="customForm.form">
      <div class="fields-grid">
        @for (element of customForm.visibleElements; track element.memberId) {
          <wr-custom-form-element [formElement]="element"
                                  [style.grid-column]="'span ' + (singleColumn() ? 12 : element.colSpan)">
          </wr-custom-form-element>
        }
      </div>
    </hau-form>
  }
</div>
